import { isPieveWorkflowDecisionRouter } from '@shared/pieve/isPieveWorkflowDecisionRouter.js';

const AI_ROUTER_LABEL = 'AI Router';

const STEP_TYPE_LABELS = Object.freeze({
  action: 'App',
  schedule: 'Schedule',
  loop: 'Loop',
  code: 'Code',
  wait: 'Wait',
  branch: 'Branch',
  router: 'Router',
  trigger: 'Trigger',
  ai: 'AI',
  flow: 'Flow',
  webhook: 'Webhook',
  respond: 'Respond'
});

/** The short label of a workflow step: its app's name, else what kind of step it is. '' when unknown. */
const getStepTopLabel = (step) => {
  if (step?.appName || step?.app?.name) {
    return step.appName || step.app.name;
  }

  if (isPieveWorkflowDecisionRouter(step)) {
    return AI_ROUTER_LABEL;
  }

  const type = String(step?.type || '').toLowerCase();
  return STEP_TYPE_LABELS[type] || '';
};

export default getStepTopLabel;
